import { PermisosService, Permisos } from '../../providers/authentication/permisos.service';
import { Component, OnInit, OnChanges, OnDestroy, Input, ViewChild, NgZone, Output, EventEmitter } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { EspacioFormulario } from '../../domain/EspacioFormulario';
import { ConfirmationService } from 'primeng/api';
import { BreadcrumbService } from '../../breadcrumb.service';
import { TranslateService } from 'ng2-translate';
import { ContenidoPlano, PlanoComponent, SeccionPlano} from 'interiores-mapa';
import { Message} from 'primeng/primeng';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { HistoricoLocalizacionContenido } from '../../domain/HistoricoLocalizacionContenido';
import { MessageService } from 'primeng/components/common/messageservice';
import { Predicate } from '../../../../node_modules/breeze-client';


import { Subscription, Observable } from 'rxjs';
import { timer } from 'rxjs/observable/timer';
import { ConnectedOverlayPositionChange } from '@angular/cdk/overlay';
import { timeHours } from 'd3';
import { forEach } from '@angular/router/src/utils/collection';



@Component({
    selector: 'app-historicoseccionchart',
	templateUrl: './historicoSeccionChart.component.html',
	styleUrls: ['./historicoSeccionChart.component.scss'],
    providers: [ConfirmationService, MessageService]
})
export class AppHistoricoSeccionChartComponent implements OnInit, OnDestroy, OnChanges {
	@ViewChild('dt_historicos') dt_historicos;
	@Input() tipologiasList = [];
	@Input() historicosList: HistoricoLocalizacionContenido[];
	@Input() mostrarSecciones: boolean;
	@Input() contenidosList = [];
	@Output() historicoSecciones = new EventEmitter<HistoricoLocalizacionContenido[]>();


	historicosListTodos: HistoricoLocalizacionContenido[];
	historicosFiltrados: HistoricoLocalizacionContenido[];
	// @Output() onChangeRange: EventEmitter<any> = new EventEmitter();

	spinner: HTMLElement;
	msgs: Message[] = [];

	public cols3;

	/* ** @INPUTS de p-dialog ** */
	public visible: boolean;

	public permisos: Permisos = new Permisos();

    displayBasic2: boolean;
    displayCustom: boolean;

//    activeIndex: number = 0;

    public tipo_informe_seleccionado: any[];
    public tipologias_contenido_seleccionadas: any[];
	public contenidos_seleccionados: any[];
	selectedHistoric: HistoricoLocalizacionContenido[] = [];

	public opcion_desde_selected;
	public opcion_hasta_selected;
	public opcion_desde_selected2;
	public opcion_hasta_selected2;
	public op_desde;
	public op_hasta;
	public op_desde2;
	public op_hasta2;
	public fAltaError = false;
	public fBajaError = false;
	//variable de opciones para dropdown donde 

	tipologia_Filter: string;
	contenido_Filter: string;

	idiomaCalendario: IdiomaCalendario;
	appComponent: any;
	fechaVisualizacion: Date = new Date();
	@ViewChild('plano') plano: PlanoComponent;
	@ViewChild('plano2') plano2: PlanoComponent;

	mapaPantallaCompletaVisible = false;
	listaNiveles: any[] = [];
	nombrePlanta: String;
	pathPlano: 'https://itsoftcdn.azureedge.net/everpaths/everpaths-b4562844-2974-40d4-8be9-fa64620b9d3c' ;
	zoomLevels: Number[]= [1, 1];
	contenidosAnt = [];
	contents: ContenidoPlano[] = [];
	sections: SeccionPlano[] = [];
	currentZoomLevel: number;
	zoomLevelsVisibilityLabels: Number[] = [1, 100];

	TIEMPO_AUTOREFRESCO = 1;
	private subscription: any; // private subscription: Subscription;
	everySecond: Observable < number >  = timer(0, this.TIEMPO_AUTOREFRESCO * 1000);

	numAla = 0; // Indice de AlaFormularioSeleccionada
	alasDrop = []; // Lista de Alas para el DropDown
	cambiandoPlanta: boolean = false;

	indiceToAdd: number;
	inicio_Fecha_Desde_Filter: any;
	inicio_Fecha_Hasta_Filter: any;
	fin_Fecha_Desde_Filter: any;
	fin_Fecha_Hasta_Filter: any;
	startHourDefault: any;
	finHourDefault: any;

	arrayFechasDesde = [];
	frameRangeValues = [0, 0];
	frameActual = 0;
	frameAnterior = 0;
	// Variables para controlar el color del contenido y el numerito que han de mostrar en el plano
	leyenda: Map<string, any>;
	leyendaArrayValores: any;

	public plantachange: boolean = false;
	ocultarIMPRESION: boolean = true;
	valorFiltroElemento: any;
	nombrePlano: string;
	public first: number;

	public positionDialogInfoInformeY: number;
	public positionDialogInfoInformeX: number;
	public dialogDescripcionInforme: boolean = false;

	constructor(
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private breadcrumbService: BreadcrumbService,
		private translate: TranslateService
	) {

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Informes.Informes') }
		]);

	

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
        this.spinner.style.display = 'none';

		// Tabla Historicos
		this.cols3 = [
			{ field: 'Elemento', header: this.translate.instant('Historicos.Elemento'), visible: true, width: '20%', imprimir: true, value:"" },
			{ field: 'Descripcion', header: this.translate.instant('Historicos.Descripcion'), visible: true, width: '20%', imprimir: false },
			{ field: 'Tipologias', header: this.translate.instant('Historicos.Tipologias'), visible: true, width: '15%', imprimir: true   },
			{ field: 'FechaDesde', header: this.translate.instant('Historicos.FechaDesde'), visible: true, width: '15%', imprimir: true   },
			{ field: 'FechaHasta', header: this.translate.instant('Historicos.FechaHasta'), visible: true, width: '15%', imprimir: true   },
			{ field: 'Seccion', header: this.translate.instant('Historicos.Seccion'), visible: true, width: '15%', imprimir: true  },
			{ field: 'Localizacion', header: '', visible: false, width: '0%' }
		];

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');
		this.startHourDefault = new Date();
		this.startHourDefault.setHours(0, 0, 0, 0);
		this.finHourDefault = new Date();
		this.finHourDefault.setHours(23, 59, 59, 999);
    }

	//#region ** CICLO VIDA **
	ngOnInit() {
		this.spinner.style.display = 'inherit';
		const that = this;
		this.alasDrop = [];
		this.historicosList = this.agruparContenidosPorSeccion(this.historicosList)
		this.historicosList.forEach(element => {
			if (element.Ala_Id !== undefined && !this.alasDrop.find(a => a.id === element.Ala_Id)) {
				this.alasDrop.push({
					label: element.Ala === element.Nivel ? element.Ala : element.Ala + ' - ' + element.Nivel,
					value: this.alasDrop.length,
					id: element.Ala_Id,
					pathPlano: element.pathPlano,
					contents: [],
					sections:[],
					idNivel: element.Nivel_Id,
					orden: 0
				});
			}
		});

		this.leyenda = new Map([]);
		this.leyendaArrayValores = [];

		this.historicosListTodos = this.historicosList;
		this.historicosFiltrados = this.historicosList;


		this.ordenarSelectorAlaNivel();
		
		
	}

	ngOnChanges(change) {
		this.alasDrop = [];

		if (change.historicosList) {
			this.historicosListTodos = change.historicosList.currentValue;
		}
		this.historicosList = this.agruparContenidosPorSeccion(this.historicosList);
		this.vaciarHistoricosPlano();
		this.selectedHistoric = [];

		this.generarArrayFechasDesde();

		this.frameActual = 0;


		this.historicosFiltrados = this.historicosList;
		this.historicosList.forEach(element => {
			if (element.Ala_Id !== undefined && !this.alasDrop.find(a => a.id === element.Ala_Id)){
				this.alasDrop.push({
					label: element.Ala === element.Nivel ? element.Ala : element.Ala + ' - ' + element.Nivel,
					value: this.alasDrop.length,
					id: element.Ala_Id,
					pathPlano: element.pathPlano,
					contents: [],
					sections: [],
					idNivel: element.Nivel_Id,
					orden: 0
				});
			}
		});

		
		this.ordenarSelectorAlaNivel();

		setTimeout(() => {
			if (this.selectedHistoric.length <= 0 && this.contarContenidosDistintos(this.historicosList) <= 1) {
				const historicosPintar = this.obtenerHistoricosRangoFechasDesde();
				this.cargarHistoricosEnPlano(historicosPintar);
			}
			
		}, 1000);



		
		

		
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	ordenarSelectorAlaNivel() {
		const that = this;
		const entityManager = that.entityManager;

		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		let includes = 'ESPACIO';
		includes = includes + ', IDIOMAS.IDIOMA';
		// includes = includes + ', ALAS.SECCIONS';
		includes = includes + ', ALAS.IDIOMAS.IDIOMA';
		// includes = includes + ', ALAS.SECCIONS.NODOS.CONTENIDOS.CONTENIDO.TIPOLOGIA_CONTENIDO';

		return entityManager.getNIVEL(predicado, includes)
		.then(function(niveles){
			if (niveles) {
				for (let index = 0; index < that.alasDrop.length; index++) {
					let orden = niveles.find(n => n.Id === that.alasDrop[index].idNivel);
					if(orden){
						that.alasDrop[index].orden = orden.NivelVertical;
					}
					
				}
			}
			let auxAlasDrop = that.alasDrop.sort(((a, b) => a.orden - b.orden));
			that.alasDrop = [];
			for (let index = 0; index < auxAlasDrop.length; index++) {
				auxAlasDrop[index].value = index;
				that.alasDrop.push(auxAlasDrop[index])
				
			}
			that.cambiarPlanta(0);
			
			
			
		})
		.catch(function(e){
			console.error(e);
			that.appComponent.showError(e.message);
			return false;
		});
		
	}
	//#endregion
	//#region ** TABLA **
	filterTipologia(event, columna) {
		const that = this;
		this.dt_historicos.filter(event.Nombre, columna, 'equals');
	}

	filterLocalizacion(value, field, op){
		this.dt_historicos.filter(value, 'Localizacion', op);
	}
	seleccionarTodo(event){
		this.onRowSelect(event);

	}
''
	seleccionarContenido(event){

		this.historicosFiltrados = this.historicosList;

		if(this.dt_historicos.filters){
			for (const key in this.dt_historicos.filters) {
				
				this.dt_historicos.filter(this.dt_historicos.filters[key].value, key, this.dt_historicos.filters[key].matchMode);
			}

		}
		

		if(event.value){
			this.selectedHistoric = [];
			this.historicosList.forEach(element => {
				if(this.dt_historicos.filteredValue && this.dt_historicos.filteredValue.length > 0){
					let existeFiltrado = this.dt_historicos.filteredValue.find(h => h.Contenido_Id === element.Contenido_Id)
					if(element.Contenido_Id === event.value && existeFiltrado){
						this.selectedHistoric.push(element)
					}
				}else if (element.Contenido_Id === event.value){
					this.selectedHistoric.push(element)
				}
			});
			this.historicosFiltrados = this.selectedHistoric;
			this.dt_historicos.first = 0;
			if(this.selectedHistoric.length > 0){
				let pagina = this.alasDrop.find(a => a.idNivel === this.selectedHistoric[0].Nivel_Id)
				this.cambiarPlanta(pagina.value)
			}


		}else{
			this.selectedHistoric = []
			this.historicosFiltrados = this.historicosList;
			this.dt_historicos.first = 0;
			this.cambiarPlanta(0);

		}




		const historicosPintar = this.obtenerHistoricosRangoFechasDesde();
		this.cargarHistoricosEnPlano(historicosPintar);

	}
	onFechaChange(dt, event, columna, tipo) {
		// Centralizamos el filtrado
		this.filtrarTabla(dt, event, columna, tipo);
	}


	onFechaAceptar(dt, calendar, columna, tipo) {

		const fecha = calendar.value ? calendar.value : new Date();
		this.onFechaChange(dt, fecha, columna, tipo);
		calendar.overlayVisible=false;
	}


	filtrarTabla(dt, event, columna, tipo){

		const that = this;
		this.historicosFiltrados = this.historicosList;

		if(that.dt_historicos.filters){
			for (const key in that.dt_historicos.filters) {
				this.dt_historicos.filter(that.dt_historicos.filters[key].value, key, that.dt_historicos.filters[key].matchMode);
			}

		}

		// Preparamos los valores de los filtros
		if (tipo === 'Desde') {
			if (columna === 'FechaDesde') {
				this.inicio_Fecha_Desde_Filter = event;
			}
			if (columna === 'FechaHasta') {
				this.inicio_Fecha_Hasta_Filter = event;
			}
		}
		if (tipo === 'Hasta') {
			if (columna === 'FechaDesde') {
				this.fin_Fecha_Desde_Filter = event;
			}
			if (columna === 'FechaHasta') {
				this.fin_Fecha_Hasta_Filter = event;
			}
		}

		// Aplicamos filtro FechaDesde
		this.historicosFiltrados = this.historicosFiltrados.filter(function (h) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.inicio_Fecha_Desde_Filter === undefined || that.inicio_Fecha_Desde_Filter === null) &&
				(that.fin_Fecha_Desde_Filter === undefined || that.fin_Fecha_Desde_Filter === null)) {
				return true;
			}
			if (that.inicio_Fecha_Desde_Filter !== undefined && that.inicio_Fecha_Desde_Filter !== null ) {
				flagDesde = that.inicio_Fecha_Desde_Filter <= new Date(h.FechaDesde);
			}
			if (that.fin_Fecha_Desde_Filter !== undefined && that.fin_Fecha_Desde_Filter !== null) {
				flagHasta = that.fin_Fecha_Desde_Filter >= new Date(h.FechaDesde);
			}
			return flagDesde && flagHasta;
		});

		// Aplicamos filtro FechaHasta
		this.historicosFiltrados = this.historicosFiltrados.filter(function (h) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.inicio_Fecha_Hasta_Filter === undefined || that.inicio_Fecha_Hasta_Filter === null) &&
				(that.fin_Fecha_Hasta_Filter === undefined || that.fin_Fecha_Hasta_Filter === null)) {
				return true;
			}
			if (that.inicio_Fecha_Hasta_Filter !== undefined && that.inicio_Fecha_Hasta_Filter !== null ) {
				flagDesde = that.inicio_Fecha_Hasta_Filter <= new Date(h.FechaHasta);
			}
			if (that.fin_Fecha_Hasta_Filter !== undefined && that.fin_Fecha_Hasta_Filter !== null) {
				flagHasta = that.fin_Fecha_Hasta_Filter >= new Date(h.FechaHasta);
			}
			return flagDesde && flagHasta;
		});


	}
	filterElemento(event, col){
		this.dt_historicos.filter(event, col, 'contains');
		document.getElementsByClassName('ui-inputtext ui-corner-all ui-state-default ui-widget')[4].attributes[5].value = event;
	}
	onRowDblClick(event, col) {

		if(event.target.innerText){
			this.valorFiltroElemento = event.target.innerText;
		}
		this.dt_historicos.filter(event.target.innerText, col, 'contains');
	}

	onRowSelect(event){
		const contenidoDistinto = this.selectedHistoric.find(s => s.Contenido_Id !== event.data.Contenido_Id)
		if(!contenidoDistinto){
		this.stopSecuenciaHistoricos();
		this.generarArrayFechasDesde();
		if (this.frameActual > this.frameRangeValues[1]) {
			this.frameActual = this.frameRangeValues[1];

		}
		const historicosPintar = this.obtenerHistoricosRangoFechasDesde();
			let AlaHistoricoUltPintar = this.alasDrop.find(i => i.id === event.data.Ala_Id);
		
			this.cambiarPlanta(AlaHistoricoUltPintar.value);

		this.cargarHistoricosEnPlano(historicosPintar);
	}else{
		this.showInfo('En este informe no puedes seleccionar elementos distintos.')
		this.selectedHistoric.length = this.selectedHistoric.length - 1;
	}

	}

	onRowUnselect(event) {
		this.stopSecuenciaHistoricos();
		this.generarArrayFechasDesde();
		if (this.frameActual > this.frameRangeValues[1]) {
			this.frameActual = this.frameRangeValues[1];

		}
		const historicosPintar = this.obtenerHistoricosRangoFechasDesde();
		this.cargarHistoricosEnPlano(historicosPintar);
	}
	//#endregion
	agruparContenidosPorSeccion(historicosList: HistoricoLocalizacionContenido[]){
		const historicosListFiltrados: HistoricoLocalizacionContenido[] = [];
		for (let index = 0; index < historicosList.length; index++) {
			let elemento: HistoricoLocalizacionContenido;
			elemento = historicosList[index];
			if(index === 0){
				historicosListFiltrados.push(elemento);
			}else if(elemento.Seccion_Id !== historicosList[index - 1].Seccion_Id){
				historicosListFiltrados.push(elemento)
			}else if(elemento.Seccion_Id === historicosList[index-1].Seccion_Id && elemento.Elemento === historicosList[index-1].Elemento && elemento.FechaDesde.toString() === historicosList[index - 1].FechaHasta.toString()){
				let desde = historicosList[index - 1].FechaDesde;
				elemento.FechaDesde = desde;
				historicosListFiltrados.length = historicosListFiltrados.length - 1;
				historicosListFiltrados.push(elemento)
			}else if(elemento.Seccion_Id === historicosList[index-1].Seccion_Id && elemento.Elemento === historicosList[index-1].Elemento && elemento.FechaDesde.toString() !== historicosList[index - 1].FechaHasta.toString()){
				historicosListFiltrados.push(elemento)
			}else if(elemento.Elemento !== historicosList[index - 1].Elemento){
				historicosListFiltrados.push(elemento)
			}
			
		}
		this.historicoSecciones.emit(historicosListFiltrados)
		//mando la tabla a la pagina 0
		if(typeof this.dt_historicos !==  'undefined'){
			this.dt_historicos.first = 0;
		}
		
		return historicosListFiltrados
	}

	agruparContenidosPorSeccion2(historicosList: HistoricoLocalizacionContenido[]){
		const historicosListFiltrados: HistoricoLocalizacionContenido[] = [];


		// Return the reduced historicosList
		const grupos = historicosList.reduce((result, currentItem) => {
			// If an historicosList already present for key, push it to the array. Otherwise create an array and push the object.
			if (!result[currentItem.Contenido_Id]) {
			result[currentItem.Contenido_Id] = [];
			}
			result[currentItem.Contenido_Id].push( currentItem )
			// return the current iteration `result` value, this will be the next iteration's `result` value and accumulate
			return result;
		}, {}); // Empty object is the initial value for result object

		// TODO: agrupar los historicos por seccion una vez separados por Contenido_id
		Object.keys(grupos).forEach(id => {
			const historicosListContenido = grupos[id];
			let elementoAgrupar:HistoricoLocalizacionContenido;
			for (let index = 0; index < historicosListContenido.length; index++) {
				const element = historicosListContenido[index];
				if (index == 0) {

					elementoAgrupar = Object.assign(new HistoricoLocalizacionContenido(), element);
					// historicosListFiltrados.push(element);
				}
				else{
					//if (historicosListFiltrados[historicosListFiltrados.length - 1].Seccion_Id != element.Seccion_Id) {
					if (elementoAgrupar.Seccion_Id != element.Seccion_Id) {
						elementoAgrupar.FechaHasta = historicosListContenido[index - 1].FechaHasta;
						historicosListFiltrados.push(elementoAgrupar);
						elementoAgrupar = Object.assign(new HistoricoLocalizacionContenido(), element);
					}
				}
			}
		});

		return historicosListFiltrados
	}

	cargarPuntoEnPlano(historicosAnt, conNumero = true, conPunto = false){

		const alaSelect = this.alasDrop[this.numAla];
		if (alaSelect) {
			const id_ala_seleccionada = alaSelect.id;
			// this.vaciarHistoricosPlano();
			if (historicosAnt.length > 0) {

				// Ponemos todos los frames a 0
				this.leyendaArrayValores.forEach(valor => {
					valor.frame = 0;
					this.leyenda.set(valor.key, valor);
				});

				// elementAnt.setHistoricoPuntoPlano();
				for (let index = 0; index < historicosAnt.length; index++) {
					const ha = historicosAnt[index];
					ha.setHistoricoSeccionPuntoPlano(17);
					// Comprobar que los contenidos pertenezcan al ala seleccionada
					if (id_ala_seleccionada === ha.Ala_Id) {
						if (this.mostrarSecciones) {
							this.sections.push(ha.seccionPlano);
						}
					}
				}

			}
		}
	}
	prueba(){
		this.selectedHistoric = [];
		return true;
	}
	cargarHistoricosEnPlano(historicosPintar, conNumero = true, conPunto = false, historicosAnt = []){

		this.generarArrayFechasDesde();
		this.generarLeyenda();
		const alaSelect = this.alasDrop[this.numAla];
		if (alaSelect) {
			const id_ala_seleccionada = alaSelect.id;
			this.vaciarHistoricosPlano();

			if (historicosAnt.length > 0) {
				this.cargarPuntoEnPlano(historicosAnt);
			}

			if (historicosPintar.length > 0) {

				// Ponemos todos los frames a 0
				this.leyendaArrayValores.forEach(valor => {
					valor.frame = 0;
					this.leyenda.set(valor.key, valor);
				});

				// elementAnt.setHistoricoPuntoPlano();
				for (let index = 0; index < historicosPintar.length; index++) {
					const element = historicosPintar[index];
					const cont = this.actualizarLeyenda(element);
					element.setHistoricoSeccionPlano(cont.frame, 16);

					// Comprobar que los contenidos pertenezcan al ala seleccionada
					if (id_ala_seleccionada === element.Ala_Id) {
							alaSelect.sections.push(element.seccionPlano);
							this.sections.push(element.seccionPlano);
					}
				}
			}
		}
	}
	desplazarContenidosCoincidentes(contents: ContenidoPlano[], contenidoPlano: ContenidoPlano): any {
				// Si hay dos o más visitas en las mismas coordenadas, desplazo la chincheta
				if (contenidoPlano) {
					this.contents.forEach((h:ContenidoPlano) => {
						if (h.getX() === contenidoPlano.getX() && h.getY() === contenidoPlano.getY()) {
							contenidoPlano.setX(contenidoPlano.getX() + 0);
							contenidoPlano.setY(contenidoPlano.getY() + 0);
					}});
				}
				return contenidoPlano;
	}

	vaciarHistoricosPlano(): any {
		this.contents = [];
		this.contents = Object.assign([], this.contents);
		this.contents.splice(0, this.contents.length);
		this.contents = Object.assign([], this.contents);

		this.sections = [];
		this.sections = Object.assign([], this.sections);
		this.sections.splice(0, this.sections.length);
		this.sections = Object.assign([], this.sections);

	}

	generarLeyenda(){
		this.leyenda = new Map([]);

		// Si no tenemos nada seleccionado en la tabla y solo hemos buscado un contenido mostramos todos sis historicos en el plano
		if (this.selectedHistoric.length <= 0 && this.contarContenidosDistintos(this.historicosList) <= 1) {

			const historicosListAux = this.historicosList.sort((a, b) =>
				new Date(a.FechaDesde).getTime() - new Date(b.FechaDesde).getTime()
			);

			const last = historicosListAux.length - 1 >= 0 ? historicosListAux.length - 1 : 0;
			const historico = historicosListAux[last];

			if (historico) {
				const contenidoEnMapa = this.leyenda.get(historico.Contenido_Id);
				if (!contenidoEnMapa) {
					this.leyenda.set(historico.Contenido_Id,
						{
							key: historico.Contenido_Id,
							nombre: historico.Elemento,
							Ala: historico.Ala,
							Nivel: historico.Nivel,
							Seccion: historico.Seccion,
							indiceColor: this.leyenda.size,
							frame: 0,
							icono: '',
							blink: false,
							negrita: false,
							noubicado: false
						});
				}
			}
		}
		else{
			this.selectedHistoric.forEach(historico => {
				const contenidoEnMapa = this.leyenda.get(historico.Contenido_Id);
				if (!contenidoEnMapa) {
					this.leyenda.set(historico.Contenido_Id,
						{
							key: historico.Contenido_Id,
							nombre: historico.Elemento,
							Ala: '',
							Nivel: '',
							Seccion: '',
							indiceColor: this.leyenda.size,
							frame: 0,
							icono: '',
							blink: false,
							negrita: false,
							noubicado: true
						});
				}

			});
		}

		this.leyendaArrayValores = Array.from( this.leyenda.values() );
		this.leyendaArrayValores.filter( l => l === undefined);

	}

	actualizarLeyenda(historico){

		const cont = this.leyenda.get(historico.Contenido_Id);
		if (!cont) {
			cont.frame = 0;
		}

		cont.frame += 1;
		cont.Ala = historico.Ala;
		cont.Nivel = historico.Nivel;
		cont.Seccion = historico.Seccion;
		this.leyenda.set(cont.key, cont);
		return cont;
	}

	contarContenidosDistintos(array){
		const result = [];
		const map = new Map();
		for (const item of array) {
			if (!map.has(item.Contenido_Id)){
				map.set(item.Contenido_Id, true);    // set any value to Map
				result.push({
					id: item.Contenido_Id,
				});
			}
		}
		return result.length;
	}


	mapaPantallaCompletaVisibleChanged(){
		this.mapaPantallaCompletaVisible = !this.mapaPantallaCompletaVisible;
	}

	//#region ** ANIMACION **

	reproducirSecuenciaHistoricos(){
		const that = this;

		// Si existe la suscripcion o esta cerrada y estaba pausado reanudamos
		if (this.subscription && !this.subscription.closed && this.subscription.isStopped) {
			this.subscription.isStopped = !this.subscription.isStopped;
			return true;
		}

		// Si no existe la suscripcion o esta cerrada la creamos
		if (!this.subscription || this.subscription.closed) {
			this.vaciarHistoricosPlano();

			// Numero de frames que no animamos tras el cambio de planta, esto evita que se siga ejecutando la animacion mientras se muestra la pantalla de carga
			const FRAMES_ESPERA_TRAS_CAMBIO_PLANTA = 1;
			let framesTranscurridosCambioPlanta = FRAMES_ESPERA_TRAS_CAMBIO_PLANTA;
			this.indiceToAdd = this.frameActual;


			this.subscription = this.everySecond
			.subscribe((seconds) => {

				// Paso de la Animacion
				if (!that.cambiandoPlanta && framesTranscurridosCambioPlanta >= FRAMES_ESPERA_TRAS_CAMBIO_PLANTA) {
					// Si solo tenemos un contenido haremos el cambio de planta automatico
					if (this.contarContenidosDistintos(this.historicosList) <= 1 || this.contarContenidosDistintos(this.selectedHistoric) <= 1) {

						const id_ala_seleccionada = this.alasDrop[this.numAla].id;
						
						const historicosPintar = this.obtenerHistoricosRangoFechasDesde(this.indiceToAdd);

						const historico = historicosPintar[0];
						if (id_ala_seleccionada === historico.Ala_Id) {

							this.ejecutarPasoAnimacion();
						}
						else {
							// Cambiar de planta
		
							const alaDrop = this.alasDrop.find( a => a.id === historico.Ala_Id);
							this.vaciarHistoricosPlano();
							this.cambiarPlanta(alaDrop.value, true);
						}
					}
					else{
						this.ejecutarPasoAnimacion();
					}
				}

				// Si acabamos de cambiar la planta ponemos a 0 el numero de frames transcurridos desde el cambio
				if (that.cambiandoPlanta) {
					framesTranscurridosCambioPlanta = 0;
				}
				// Si no acabamos de cambiar la planta incrementamos el numero de frames trasncurridos
				else {
					framesTranscurridosCambioPlanta += 1;
				}
			});
		}
	}

	animacionEnCurso(){ // Devuelve true si esta reproduciendose la animacion aunque este pausada
		// Si solo tenemos un contenido haremos el cambio de planta automatico
		if (this.contarContenidosDistintos(this.historicosList) <= 1) {
			const existeSuscription = this.subscription && !this.subscription.closed;
			if (!existeSuscription) {
				return false;
			}
			if (existeSuscription)
			{
				return true;
			}
		}
		else {
			return false;
		}
	}

	ejecutarPasoAnimacion(){

		const historicosAnt = this.obtenerPuntosHistoricosAnteriores(this.indiceToAdd - 1); // this.obtenerPuntosPasosAnteriores();
		const historicosPintar = this.obtenerHistoricosRangoFechasDesde(this.indiceToAdd);

		this.cargarHistoricosEnPlano(historicosPintar, false, false, historicosAnt);
		// Tras cargar el contenido en el plano incrementamos el numero de frame a animar

		this.frameActual = this.indiceToAdd;
		this.indiceToAdd += 1;
		this.comprobarCambioDePlantaContenido(this.indiceToAdd);
		// this.actualizarLeyenda(historico);
		// Pausamos y Reseteamos el indice cuando llegamos al ultimo elemento
		if (this.indiceToAdd >= this.frameRangeValues[1] + 1) {
			this.pausarSecuenciaHistoricos();
			this.indiceToAdd = this.frameRangeValues[0];
		}
	}


	comprobarCambioDePlantaContenido(indiceToAdd){

		if (indiceToAdd === 0){
			return false;
		}
		const historicosPintar = this.obtenerHistoricosRangoFechasDesde(this.indiceToAdd);
		const historicosPintados = this.obtenerHistoricosRangoFechasDesde(this.indiceToAdd - 1);
		historicosPintar.forEach(element => {
			const historicoPintado = historicosPintados.find(h => h.Contenido_Id === element.Contenido_Id);
			const historicoPintadoNoUbicado = historicosPintados.find(hn => hn.Contenido_Id !== element.Contenido_Id);
			if(historicoPintado && element.Ala_Id !== historicoPintado.Ala_Id){
				const leyenda = this.leyendaArrayValores.find(l => l.key === historicoPintado.Contenido_Id);
				leyenda.blink = true;
			}
			else if(!historicoPintado){
				const leyenda = this.leyendaArrayValores.find(l => l.Ala === '');
				leyenda.noubicado = true;

			}
			else{
				const leyenda = this.leyendaArrayValores.find(l => l.key === historicoPintado.Contenido_Id);
				leyenda.blink = false;
			}
		});

		historicosPintar.forEach(element => {
			const idAlaSeleccionada = this.alasDrop[this.numAla].id;
			if(element.Ala_Id !== idAlaSeleccionada){
				const leyenda = this.leyendaArrayValores.find(l => l.key === element.Contenido_Id);
				leyenda.negrita = true;
			}
			else{
				const leyenda = this.leyendaArrayValores.find(l => l.key === element.Contenido_Id);
				leyenda.negrita = false;
			}
		});
	}
	stopSecuenciaHistoricos(){
		this.frameActual = 0;
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
		const historicosPintar = this.obtenerHistoricosRangoFechasDesde();
		this.cargarHistoricosEnPlano(historicosPintar);
	}

	pausarSecuenciaHistoricos(){
		if (this.subscription) {
			this.subscription.isStopped = !this.subscription.isStopped;
		}
	}

	generarArrayFechasDesde(){

		this.frameRangeValues[0] = 0;
		this.arrayFechasDesde = [];
		let historicos = [];

		// Ordenamos los historicos por fecha
		if (this.selectedHistoric.length <= 0 && this.contarContenidosDistintos(this.historicosList) <= 1) {
			this.historicosList =  this.historicosList.sort((a, b) =>
				new Date(a.FechaDesde).getTime() - new Date(b.FechaDesde).getTime()
			);
			historicos = this.historicosList;
		}
		else {
			this.selectedHistoric = this.selectedHistoric.sort((a, b) =>
				new Date(a.FechaDesde).getTime() - new Date(b.FechaDesde).getTime()
			);
			historicos = this.selectedHistoric;
		}

		// Cogemos las fechas desde sin repeticion de los historicos
		historicos.forEach(element => {
			const fechaEncontrada = this.arrayFechasDesde.find( f => f === element.FechaDesde);
			if (!fechaEncontrada) {
				this.arrayFechasDesde.push(element.FechaDesde);
			}
		});

		this.frameRangeValues[1] = this.arrayFechasDesde.length <= 0 ? 0 : this.arrayFechasDesde.length - 1;
	}
	//#endregion

	//#region ** Slider Frame **
	onSliderChange($event){
		// Cambiamos el indice de la animacion al seleccionado en el slider
		this.indiceToAdd = this.frameActual;
		const historicosPintar = this.obtenerHistoricosRangoFechasDesde(this.indiceToAdd);
		this.cargarHistoricosEnPlano(historicosPintar, false);
	}

	obtenerHistoricosRangoFechasDesde(indiceToAdd?){

		let historicos: HistoricoLocalizacionContenido[] = [];
		if (indiceToAdd < 0) {
			return historicos;
		}

		if (this.selectedHistoric.length <= 0 && this.contarContenidosDistintos(this.historicosList) <= 1) {
			historicos = this.historicosList;

		}
		else{
			
			historicos = this.selectedHistoric;

		}

		historicos = historicos.sort((a, b) =>
			new Date(a.FechaDesde).getTime() - new Date(b.FechaDesde).getTime()
		);

		let historicosPintar = [];
		if (indiceToAdd !== undefined) {
			const desde = this.arrayFechasDesde[indiceToAdd];
			const fechaDesde = new Date(desde);

			historicosPintar = historicos.filter( h => h.FechaDesde === desde);
			// Buscar en selectedHistoric otros historicos de distinto contenido que tengan la fechaDesde anterior a la fecha desde y fecha Hasta posterior
			historicosPintar = historicos.filter( h => {
				const fd = new Date(h.FechaDesde);
				const fh = new Date(h.FechaHasta);
				const condicion_1 = fd.getTime() === fechaDesde.getTime();
				const condicion_2_1 =  fd.getTime() <= fechaDesde.getTime();
				const condicion_2_2 = fh.getTime() > fechaDesde.getTime();
				return condicion_1|| (condicion_2_1 && condicion_2_2);
			});


		}
		else {
			
			historicosPintar = historicos;

		}



		return historicosPintar;
	}

	obtenerPuntosHistoricosAnteriores(indiceToAdd){

		let historicos: HistoricoLocalizacionContenido[] = [];
		if (indiceToAdd < 0) {
			return historicos;
		}
		if (this.selectedHistoric.length <= 0 && this.contarContenidosDistintos(this.historicosList) <= 1) {
			historicos = this.historicosList;
		}
		else{
			historicos = this.selectedHistoric;
		}

		historicos = historicos.sort((a, b) =>
			new Date(a.FechaDesde).getTime() - new Date(b.FechaDesde).getTime()
		);

		let puntosPintar = [];
		if (indiceToAdd !== undefined) {
			const desde = this.arrayFechasDesde[indiceToAdd];
			const fechaDesde = new Date(desde);

			puntosPintar = historicos.filter( h => {
				const fd = new Date(h.FechaDesde);
				return fd <= fechaDesde;
			});
		}
		else {
			puntosPintar = historicos;
		}

		return puntosPintar;
	}
/*
	obtenerPuntosPasosAnteriores(){
		this.frameAnterior = this.indiceToAdd - 1;
		let historicosAnt = [];
		if(this.frameAnterior >= 0){
			historicosAnt = this.obtenerHistoricosRangoFechasDesde(this.frameAnterior);
		}
		this.frameAnterior = this.frameAnterior - 1;
		while(this.frameAnterior >= 0){
			const historicosAnteriores = this.obtenerHistoricosRangoFechasDesde(this.frameAnterior);
			historicosAnt.push(historicosAnteriores[0]);
			this.frameAnterior = this.frameAnterior - 1;
		}

		return historicosAnt;
	}
*/
	//#endregion

	//#region ** Selector Planta **
	getFirsAla() {
		if (this.alasDrop && this.alasDrop.length > 0) {
		  return this.alasDrop[0].label;
		}
		return '';
	}

	cambiarPlanta(indice, animado = false) {
		// Mostramos pantalla de cambio de planta
		if (animado) {
			this.cambiandoPlanta = true;

			// Esperamos a que se muestre la pantalla para cambiar el ala
			setTimeout(() => {
				this.numAla = indice;
				const res = this.alasDrop.find(a => a.value === indice);
				const historicoConEsaAla = this.historicosList.find( h => h.Ala_Id === res.id);

				if (historicoConEsaAla) {
					this.pathPlano = historicoConEsaAla.pathPlano;
					this.nombrePlano = historicoConEsaAla.Ala === historicoConEsaAla.Nivel ? historicoConEsaAla.Ala : historicoConEsaAla.Ala + "-" +  historicoConEsaAla.Nivel;
					this.zoomLevels = historicoConEsaAla.zoomLevels;
					this.currentZoomLevel = 1;
				}
			}, this.TIEMPO_AUTOREFRESCO * 1000);
		}
		else {
			this.numAla = indice;
			const res = this.alasDrop.find(a => a.value === indice);
			const historicoConEsaAla = this.historicosList.find( h => h.Ala_Id === res.id);

			if (historicoConEsaAla) {
				this.pathPlano = historicoConEsaAla.pathPlano;
				this.nombrePlano = historicoConEsaAla.Ala === historicoConEsaAla.Nivel ? historicoConEsaAla.Ala : historicoConEsaAla.Ala + "-" +  historicoConEsaAla.Nivel;
				this.zoomLevels = historicoConEsaAla.zoomLevels;
				this.currentZoomLevel = 1;
			}
		}

	}

	//#endregion

	//#region PLANO CALLBACKS **
	public onSVGLoaded(event) {

		// Si estamos animando el historico no cargamos todos los contenidos, dejamos que la animacion lo haga
		if (!this.subscription || this.subscription.closed) {
			const historicosPintar = this.obtenerHistoricosRangoFechasDesde();
			this.cargarHistoricosEnPlano(historicosPintar);
		}
		else {
			const historicosPintar = this.obtenerHistoricosRangoFechasDesde();
			this.cargarHistoricosEnPlano(historicosPintar);
			this.ejecutarPasoAnimacion();
		}
		this.cambiandoPlanta = false;
	}

	public onSVGClicked(event) {

	}

	public onContentClicked(event){

	}

	//#endregion
wSuccess
	//#region ** Aux Pintar Fechas **
	/*convertirFechaUTC(fechaString){
		const FechaUbicacionaux = new Date(fechaString);
		const FechaUbicacion = new Date(Date.UTC(FechaUbicacionaux.getFullYear() , FechaUbicacionaux.getMonth() , FechaUbicacionaux.getDate() , FechaUbicacionaux.getHours() , FechaUbicacionaux.getMinutes() , FechaUbicacionaux.getSeconds()));
		return FechaUbicacion;
	}
	*/

	getDiaPintar(){
		if (this.arrayFechasDesde && this.arrayFechasDesde[this.frameActual]) {
			/*const fechaAux = this.arrayFechasDesde[this.frameActual];
			const fecha = this.convertirFechaUTC(fechaAux);

			return fecha;*/
			const fechaAux = this.arrayFechasDesde[this.frameActual];
			return fechaAux;
		}
	}
	getHoraInicioPintar(){
		if (this.arrayFechasDesde && this.arrayFechasDesde[this.frameActual]) {
/*
			const fechaAux = this.arrayFechasDesde[this.frameActual];
			const fecha = this.convertirFechaUTC(fechaAux);

			return fecha;*/
			const fechaAux = this.arrayFechasDesde[this.frameActual];
			return fechaAux;
		}
	}

	//#endregion

	//#region  **  Gestion Mensajes **
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showInfo = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'info',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}
	//#endregion

	descripcionInforme(event){
		this.positionDialogInfoInformeX = event.x;
		this.positionDialogInfoInformeY = event.y;
		this.dialogDescripcionInforme = !this.dialogDescripcionInforme;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/historicoSeccionChart/historicoSeccionChart.component.ts